import { PaletteColor } from "@brexhq/metal-foundation-shared";
import styled from "@emotion/styled";
import { border, padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { getModuleThemeColors } from "@brexhq/next/src/components/pageBuilder/ModuleLayout";
import { SubtitleL } from "@brexhq/shared/components/Typography/Components";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { SanityComparisonTableProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

import {
  ComparisonTableHeaderRow,
  MobileHeaderRow,
} from "./components/ComparisonTableHeaderRow";
import { ComparisonTableRow } from "./components/ComparisonTableRow";

const Table = styled.table({
  width: "100%",
  height: "100%",
  margin: 0,
  borderCollapse: "collapse",
  tableLayout: "fixed",
});

const MobileHeaderCell = styled.td<{ borders: PaletteColor }>(
  ({ borders, theme }) => ({
    margin: 0,
    ...padding(theme.spacing[24], 0),
    ...border("bottom", 1, "solid", borders),
  }),
);

interface Props {
  table: SanityComparisonTableProps;
  theme: ModuleThemeType;
  withBorder?: boolean;
}

export const ComparisonTable = ({
  theme,
  table: {
    headerColumnTitle,
    columnHeaders = [],
    rowHeaders = [],
    rowData = [],
  },
  withBorder = true,
}: Props) => {
  const {
    standard: { background, borders },
  } = getModuleThemeColors(theme);

  const showTHead =
    headerColumnTitle ||
    columnHeaders.some(
      (header) => header.columnHeaderTitle && header.columnHeaderTitle !== " ",
    );

  return (
    <Container width="100%">
      <Table>
        {showTHead && (
          <thead>
            <ComparisonTableHeaderRow
              headerColumnTitle={headerColumnTitle}
              columnHeaders={columnHeaders}
              theme={theme}
              withBorder={withBorder}
            />
          </thead>
        )}
        <tbody>
          {headerColumnTitle && (
            <MobileHeaderRow backgroundColor={background}>
              <MobileHeaderCell
                colSpan={columnHeaders.length}
                borders={borders}
              >
                <SubtitleL>{headerColumnTitle}</SubtitleL>
              </MobileHeaderCell>
            </MobileHeaderRow>
          )}
          {rowHeaders?.map((rowHeader, i) => (
            <ComparisonTableRow
              key={rowHeader.rowHeaderTitle}
              index={i}
              rowHeader={rowHeader}
              rowData={rowData[i].tableRow}
              theme={theme}
              columnCount={columnHeaders.length}
            />
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
